<div class="entity-lookup-dialog resource-visibility-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Resource Visibility</h2>
    <button
      mat-icon-button
      class="close-button"
      tabindex="-1"
      aria-label="Close"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="visibility-content">
    <!-- Resource identity -->
    <p class="visibility-resource">
      Setting visibility for <strong>{{ data.userName }}</strong>
    </p>

    @switch (loadState) {
      @case ('loading') {
        <div class="dialog-status">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }
      @case ('error') {
        <app-error-state
          message="We couldn't load the visibility options. Please try again."
          (retry)="loadModes(true)"
        ></app-error-state>
      }
      @default {
        <!-- System-default summary -->
        <div class="policy-intro">
          <mat-icon class="policy-intro__icon">info</mat-icon>
          <p class="policy-intro__text">
            By default this resource uses the <strong>system default</strong> —
            visibility is filtered by <strong>{{ systemDefaultLabel }}</strong
            >.
          </p>
        </div>

        <!-- Per-resource override options -->
        <p class="policy-options-label">
          To set a policy for this specific resource, choose from the following
          options:
        </p>

        <mat-radio-group
          class="policy-options"
          [(ngModel)]="selectedCode"
          aria-label="Resource visibility policy"
        >
          <!-- Use the system default (no per-resource override) -->
          <mat-radio-button class="policy-option" [value]="inheritCode">
            <span class="policy-option__title">System default</span>
            <span class="policy-option__sub"
              >Filter visibility by {{ systemDefaultLabel }}</span
            >
          </mat-radio-button>

          <!-- Explicit per-resource overrides -->
          @for (mode of modes; track mode.code) {
            <mat-radio-button class="policy-option" [value]="mode.code">
              <span class="policy-option__title">{{ mode.label }}</span>
              <span class="policy-option__sub">{{ mode.description }}</span>
            </mat-radio-button>
          }
        </mat-radio-group>
      }
    }
  </mat-dialog-content>

  @if (loadState === 'ready') {
    <mat-dialog-actions class="dialog-actions">
      <button mat-flat-button class="save-button" (click)="save()">Save</button>
    </mat-dialog-actions>
  }
</div>
